module.exports = __webpack_public_path__ + "static/010.thumb-4bd45ffe1d47f4ac750a6968de28305d.jpg";